var map = {
	"./1AGN.png": 63173,
	"./2AGN.png": 81702,
	"components/Catalog/AGN/img/allDoor/Silver/1AGN.png": 63173,
	"components/Catalog/AGN/img/allDoor/Silver/2AGN.png": 81702
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70010;